(function () {
  'use strict';
  var boot = document.getElementById('mtg-home-tracking');
  if (!boot || window.MTGHomeTracking || !document.body.classList.contains('mt-template-index')) return;
  var preview = boot.getAttribute('data-mode') !== 'live' ||
    !!(window.Shopify && (window.Shopify.designMode || (window.Shopify.theme && window.Shopify.theme.role !== 'main'))) ||
    new URLSearchParams(location.search).has('preview_theme_id');
  var sections = [
    ['hero','__image_banner_Ckpzkn'],
    ['benefits','__custom_liquid_mtgP0'],
    ['collections','__collection_list_aaAgdE'],
    ['category_cards','__multicolumn_bJqDCx'],
    ['featured_products','__featured_collection_rHxggU'],
    ['buying_guide','__image_with_text_yN3wJV']
  ];
  var paths = {
    '/':'home','/collections/pedestrian-gates':'pedestrian_gates',
    '/collections/driveway-gates':'driveway_gates','/collections/pickets':'pickets',
    '/collections/all':'all_products','/products':'products',
    '/pages/about-us':'workshop','/pages/custom-sizing':'custom_quote',
    '/pages/faqs':'faqs','/pages/how-to-care-for-your-timber-gate':'care',
    '/pages/how-to-measure':'measuring','/pages/contact':'contact',
    '/pages/picket-calculator':'picket_calculator','/pages/gate-design-gallery':'gallery',
    '/pages/custom-timber-gates-sydney':'custom_gate_guide',
    '/pages/driveway-double-timber-gates-sydney':'driveway_guide',
    '/pages/pedestrian-side-timber-gates-sydney':'pedestrian_guide',
    '/pages/timber-gate-buying-guide':'buying_guide',
    '/policies/refund-policy':'refund_policy','/policies/privacy-policy':'privacy_policy',
    '/policies/terms-of-service':'terms','/policies/shipping-policy':'shipping_policy',
    '/policies/contact-information':'contact_policy'
  };
  var records = new Map(), links = new WeakMap(), observed = new Map();
  var observer, poll, attempts = 0, privacyRequested = false, allowedBefore = false;
  var diagnostic = {mode:preview?'preview':'live',mapped:[],events:[],status:'starting'};
  var diagnosticNode;
  function note() {
    document.documentElement.setAttribute('data-mtg-home-tracking', diagnostic.status);
    if (!preview) return;
    if (!diagnosticNode) {
      diagnosticNode = document.createElement('script');
      diagnosticNode.id = 'mtg-home-diagnostics';
      diagnosticNode.type = 'application/json';
      document.body.appendChild(diagnosticNode);
    }
    diagnosticNode.textContent = JSON.stringify(diagnostic);
  }
  function permitted() {
    if (preview) return true;
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  }
  function ready() { return permitted() && (preview || typeof window.gtag === 'function'); }
  function send(name, record) {
    if (!ready()) return false;
    var params = {
      send_to:'G-E64YVYMMTP',home_section:record.section,home_link:record.link,
      home_destination:record.destination,measurement_version:'home-v1',
      page_location:location.origin + location.pathname,page_referrer:''
    };
    try {
      if (preview) {
        diagnostic.events.push({event:name,params:params});
        if (diagnostic.events.length > 60) diagnostic.events.shift();
        note();
      } else {
        window.gtag('event', name, params);
      }
      return true;
    } catch (_) { return false; }
  }
  function destination(anchor) {
    try {
      var raw = anchor.getAttribute('href') || '';
      if (/^tel:/i.test(raw)) return null; // Site-wide contact-v1 owns phone clicks.
      if (/^mailto:/i.test(raw)) return {link:'email',destination:'email'};
      var url = new URL(raw, location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.username || url.password) return null;
      var path = url.pathname.replace(/\/$/, '') || '/';
      if (path === '/' && url.hash) return null;
      if (path === '/pages/faqs' && url.hash === '#delivery') return {link:'delivery',destination:path};
      if (paths[path]) return {link:paths[path],destination:path};
      // Only actual public product handles; never query strings or free text.
      if (/^\/products\/[a-z0-9-]{1,80}$/.test(path)) return {link:path.slice(10),destination:path};
    } catch (_) {}
    return null;
  }
  function register(root, section, measureViews) {
    if (!root) return;
    root.querySelectorAll('a[href]').forEach(function(anchor) {
      var dest = destination(anchor);
      if (!dest) return;
      var key = section + ':' + dest.link;
      var record = records.get(key);
      if (!record) {
        record = {section:section,link:dest.link,destination:dest.destination,viewed:false,targets:[],timer:null};
        records.set(key,record);
      }
      links.set(anchor,record);
      if (!measureViews) return;
      var target = anchor.closest('.card-wrapper, .multicolumn-card') || anchor;
      if (record.targets.indexOf(target) === -1) record.targets.push(target);
      var items = observed.get(target) || [];
      if (items.indexOf(record) === -1) items.push(record);
      observed.set(target,items);
    });
  }
  function visible(target) {
    if (!target.isConnected || !target.getClientRects().length) return false;
    var rect = target.getBoundingClientRect();
    var style = window.getComputedStyle(target);
    if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return false;
    var width = Math.max(0,Math.min(rect.right,window.innerWidth)-Math.max(rect.left,0));
    var height = Math.max(0,Math.min(rect.bottom,window.innerHeight)-Math.max(rect.top,0));
    return rect.width > 0 && rect.height > 0 && (width*height)/(rect.width*rect.height) >= 0.5;
  }
  function cancel(record) { if (record.timer !== null) window.clearTimeout(record.timer); record.timer = null; }
  function view(record) {
    if (!record.viewed && send('mtg_home_item_view',record)) record.viewed = true;
  }
  function assess(record) {
    if (record.viewed) return;
    if (document.visibilityState !== 'visible' || !ready() || !record.targets.some(visible)) {cancel(record); return;}
    if (record.timer !== null) return;
    record.timer = window.setTimeout(function() {
      record.timer = null;
      if (document.visibilityState === 'visible' && ready() && record.targets.some(visible)) view(record);
    },1000);
  }
  function refresh() {
    var allowed = permitted();
    if (!allowed) records.forEach(cancel);
    // No events or historical clicks are queued while consent is absent.
    if (allowed !== allowedBefore) {
      allowedBefore = allowed;
      if (!allowed) diagnostic.status = 'consent-blocked';
    }
    diagnostic.status = preview ? 'preview' : !allowed ? 'consent-blocked' :
      typeof window.gtag !== 'function' ? 'waiting-for-google-tag' : 'ready';
    if (ready()) records.forEach(assess);
    note();
  }
  function loadPrivacy() {
    if (preview || privacyRequested || !(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) return;
    if (window.Shopify.customerPrivacy) return;
    privacyRequested = true;
    try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],refresh); } catch (_) {}
  }
  sections.forEach(function(s) {register(document.querySelector('main [id$="'+s[1]+'"]'),s[0],true);});
  register(document.querySelector('.shopify-section[id$="__header"]'), 'header', false);
  register(document.querySelector('footer'), 'footer', false);
  document.addEventListener('click', function(event) {
    try {
      if (event.defaultPrevented || event.button > 0 || (!preview && event.isTrusted !== true)) return;
      var anchor = event.target.closest && event.target.closest('a[href]');
      var record = anchor && links.get(anchor);
      if (!record || !ready()) return;
      // A deliberate activation is also evidence that this item was encountered.
      if (record.targets.length) {cancel(record);view(record);}
      send('mtg_home_click',record);
    } catch (_) {}
  });
  if (typeof window.IntersectionObserver === 'function') {
    observer = new window.IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {(observed.get(entry.target)||[]).forEach(assess);});
    },{threshold:[0,0.5,1]});
    observed.forEach(function(_,target) {observer.observe(target);});
  }
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('visibilitychange', function() {records.forEach(cancel);refresh();});
  window.addEventListener('pageshow', refresh);
  // Resize can alter whether a tall card meets the exposure threshold.
  window.addEventListener('resize', refresh, {passive:true});
  diagnostic.mapped = Array.from(records.values()).map(function(r) {
    return {section:r.section,link:r.link,destination:r.destination,exposure:r.targets.length>0};
  });
  window.MTGHomeTracking = {version:'home-v1'};
  loadPrivacy();refresh();
  poll = window.setInterval(function() {
    loadPrivacy();refresh();
    if (++attempts >= 60 || ready()) window.clearInterval(poll);
  },500);
}());

